import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrencyEnum, Locale} from '@magieno/common';
import {AdvancedForm, AdvancedFormArray, AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {SalaryDividendOptions,} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {IncomeTaxPersonalChildCampOptions,} from '../../../../../../../../../../../common/src/options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';
import {IncomeTaxPersonalChildQuebecInSalaryDividendOptions,} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-quebec-in-salary-dividend.options';
import {IncomeTaxPersonalChildFederalInSalaryDividendOptions,} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-federal-in-salary-dividend.options';
import {IncomeTaxPersonalInSalaryDividendOptions,} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-in-salary-dividend.options';
import {IncomeTaxPersonalChildInSalaryDividendOptions,} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-in-salary-dividend.options';


@Component({
  selector: 'app-salary-dividend-personal-tax-child-form',
  templateUrl: './salary-dividend-personal-tax-child-form.component.html',
  styleUrls: ['./salary-dividend-personal-tax-child-form.component.scss'],
  standalone: false,
})
export class SalaryDividendPersonalTaxChildFormComponent {

  @Input()
  childForm: AdvancedFormGroup<IncomeTaxPersonalChildInSalaryDividendOptions>;

  @Input()
  index: number;

  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get camps(): AdvancedFormArray<IncomeTaxPersonalChildCampOptions> {
    return this.childForm.formElements.camps as AdvancedFormArray<IncomeTaxPersonalChildCampOptions>;
  }

  get federalForm(): AdvancedFormGroup<IncomeTaxPersonalChildFederalInSalaryDividendOptions> {
    return this.childForm.formElements.federal as AdvancedFormGroup<IncomeTaxPersonalChildFederalInSalaryDividendOptions>;
  }

  get quebecForm(): AdvancedFormGroup<IncomeTaxPersonalChildQuebecInSalaryDividendOptions> {
    return this.childForm.formElements.quebec as AdvancedFormGroup<IncomeTaxPersonalChildQuebecInSalaryDividendOptions>;
  }

  get incomeTaxPersonalForm(): AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions> {
    return this.form.formElements.incomeTaxPersonalOptions as AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions>;
  }

  refresh() {
  }
}
